export const profiles = {
  superAdmin: 1,
  venuesAdmin: 2,
  concessionAdmin: 3,
  seller: 4,
  consultation: 5,
  pos: 6,
  recharges: 7,
  preparer: 8,
  warehouseClerk: 9,
  runner: 10,
};
